import { useContext } from 'react';
import { AuthContext } from '@entities/auth';

export const useAuthSignOut = () => {
  const { signOut } = useContext(AuthContext);

  return () => signOut();
};
